/* eslint-disable no-undef */
import { axiosInstance } from '../common';

const FETCH_REFRESH_TOKEN = `${process.env.API_BIFROST_URL}/${process.env.VERSION_V1}/access_token/refresh`;
const FETCH_ACCESS_TOKEN = `${process.env.API_BIFROST_URL}/${process.env.VERSION_V1}/access_token/access_token`;
export const fetchRefreshToken = (headers, payload) => axiosInstance.post(FETCH_REFRESH_TOKEN, payload, { headers });
export const fetchAccessToken = (headers, payload) => axiosInstance.post(FETCH_ACCESS_TOKEN, payload, { headers });